import React from 'react';
import { Building2, TrendingUp, DollarSign, Target, Users, Calendar, Shield, Briefcase } from 'lucide-react';
import '../../styles/website/B2BSection.css';

const B2BSection = () => {
  return (
    <section className="premium-section b2b-section" id="b2b">
      <div className="premium-container">
        <div className="premium-icon-wrapper">
          <div className="premium-icon">
            <Building2 size={64} />
          </div>
          <div className="icon-glow"></div>
        </div>
        
        <div className="premium-content">
          <span className="premium-badge">Business Solutions</span>
          <h2 className="premium-title">Companies & Organisations</h2>
          <p className="premium-tagline">Business decisions with clarity — from start to success.</p>
          
          <p className="premium-description">
            For companies, startups, and teams — get clarity on revenue, funding, market timing, partnerships, and the best phases to grow or take decisions.
          </p>
          
          <div className="premium-features">
            <div className="feature-item">
              <TrendingUp size={20} />
              <span>Growth cycles & revenue windows</span>
            </div>
            <div className="feature-item">
              <DollarSign size={20} />
              <span>Funding chances, valuation phases</span>
            </div>
            <div className="feature-item">
              <Target size={20} />
              <span>Best times for launch & incorporation</span>
            </div>
            <div className="feature-item">
              <Shield size={20} />
              <span>Risk periods for business</span>
            </div>
            <div className="feature-item">
              <Users size={20} />
              <span>Partnership compatibility</span>
            </div>
            <div className="feature-item">
              <Calendar size={20} />
              <span>Market timing</span>
            </div>
            <div className="feature-item">
              <Briefcase size={20} />
              <span>Leadership graph & stability forecast</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default B2BSection;
